import { gql } from '@apollo/client';

export const GET_DRAFT_BY_ID = gql`
    query getDraftById($id: String!) {
        getDraftById(id: $id) {
            hasStoryAnalysis
            # TRIL-604/605: the body that was actually analysed, persisted server-side.
            # The snapshot used to be in-memory only and was re-seeded from the CURRENT
            # draft on load, which silently adopted post-analysis edits as "analysed".
            lastAnalyzedText
            storyAnalysis
            id 
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            article
            createdAt
            updatedAt
        }
    }
`;
